import React from 'react';
import { LanguageProvider } from './contexts/LanguageContext';
import ComingSoon from './components/ComingSoon';

function App() {
  return (
    <LanguageProvider>
      <div className="App min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-900">
        <ComingSoon />
      </div>
    </LanguageProvider>
  );
}

export default App;
